import { useAppSelector } from "@/app/hooks";
import { PDFPaperSize } from "@/constants/mapStyles";
import classNames from "classnames";
import { ReactNode } from "react";

interface SurveyPDFPageProps {
  children?: ReactNode;
  mode: string | undefined;
}

const SurveyPDFPage = (props: SurveyPDFPageProps) => {
  const { children, mode } = props;
  const { currentSurvey } = useAppSelector(
    (state) => state.interactiveSurvey,
  );
  const isPortrait = currentSurvey?.pdfPaperSize === PDFPaperSize.Portrait;

  // Mode-specific styling mapping
  const styleMap = {
    PDF: isPortrait ? "print-page-portrait" : "print-page-landscape",
    FlyerPreview: isPortrait
      ? "preview-flyer-portrait"
      : "preview-flyer-landscape",
  };

  // Default to PDFPreview styling for undefined or unrecognized modes
  const modeSpecificClass =
    styleMap[mode as keyof typeof styleMap] ||
    (isPortrait ? "preview-page-portrait" : "preview-page-landscape");

  return (
    <div
      className={classNames(
        modeSpecificClass,
        "common-pdf-orientation",
        "flex",
      )}
    >
      {children}
    </div>
  );
};

export default SurveyPDFPage;
